



import { BaseEntityResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDataResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseResponse } from '@m4u-angular/base/entities/BaseEntities';
import { GenericListEntity } from '@m4u-angular/base/entities/BaseEntities';
import { DataGroupInfo } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { APIGatewayService } from '@m4u-angular/core/gateway/APIGateway.service';
import { EnumRequestProgressTracking } from '@m4u-angular/core/framework/sysenums.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactPerson } from './../entities/contactperson.entity';
@Injectable()
export class ContactPersonEndpoint extends BaseEndpointCRUD<ContactPerson>
{
    constructor(api: APIGatewayService) {super("ContactPerson", api);}
	

    public  ListEx(iCustomerID: number) : Observable<BaseEntitiesResponse<ContactPerson>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'ListEx',  {iCustomerID: iCustomerID} );
    }

    public  List(options: DataLoadOptions) : Observable<BaseEntitiesResponse<ContactPerson>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'List',  options?.GetLoadOptions() );
    }

    public override Get(EntryID: number) : Observable<BaseEntityResponse<ContactPerson>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'Get',  {EntryID: EntryID} );
    }

    public override Save(Entity: ContactPerson) : Observable<BaseEntityResponse<ContactPerson>>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'Save', Entity,  undefined );
    }
}

